var _path, _path2, _g, _path3, _path4, _g2, _path5, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvoUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 963,
    height: 197,
    viewBox: "0 0 963 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.358 2.28418C445.754 2.28418 411.111 41.7451 411.111 98.2472C411.111 146.218 411.124 180.141 411.124 180.141C411.126 188.322 417.866 194.978 426.143 194.978H426.149C434.43 194.975 441.166 188.313 441.164 180.126C441.164 179.724 441.151 145.927 441.151 98.2472C441.151 58.6038 462.935 31.9688 495.358 31.9688C527.85 31.9688 549.684 58.5866 549.684 98.2035C549.684 143.148 549.636 179.449 549.636 180.082C549.63 184.046 551.189 187.776 554.022 190.581C556.857 193.389 560.625 194.937 564.657 194.942C572.929 194.942 579.665 188.292 579.676 180.118C579.676 180.118 579.722 143.562 579.722 98.2035C579.722 41.728 545.031 2.28418 495.358 2.28418Z",
    fill: "#00AA55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_1790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 174,
    height: 193
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00128174 2.24902H173.334V194.964H0.00128174V2.24902Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_1790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4001 31.9697C116.059 31.9697 134.063 39.7706 146.791 53.3723C151.98 58.9146 160.24 60.1048 166.43 56.1976C170.151 53.8515 172.621 50.0337 173.201 45.7254C173.785 41.4114 172.423 37.0898 169.465 33.8691C150.714 13.4532 123.954 1.8706 96.2182 2.25846C70.2351 2.56457 45.7759 13.2364 27.3417 32.3081C8.88829 51.3969 -0.803501 76.0812 0.0536362 101.813C0.881945 126.836 11.3886 150.258 29.6345 167.761C47.9226 185.302 71.9858 194.964 97.4001 194.964C124.64 194.964 150.839 183.503 169.279 163.515C172.1 160.46 173.499 156.517 173.218 152.406C172.94 148.341 171.047 144.666 167.887 142.055C161.682 136.93 152.561 137.542 147.118 143.453C133.121 158.652 113.209 166.531 92.5014 165.078C59.3921 162.747 32.6152 136.295 30.2206 103.545C28.8504 84.827 35.1962 66.9684 48.086 53.2583C60.8085 39.7307 78.7814 31.9697 97.4001 31.9697Z",
    fill: "#00AA55"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.88 98.6085C354.88 135.353 324.663 165.248 287.522 165.248C250.379 165.248 220.16 135.353 220.16 98.6085C220.16 61.8645 250.379 31.9688 287.522 31.9688C324.663 31.9688 354.88 61.8645 354.88 98.6085ZM287.522 2.25C233.815 2.25 190.122 45.4774 190.122 98.6085C190.122 151.74 233.815 194.965 287.522 194.965C341.228 194.965 384.921 151.74 384.921 98.6085C384.921 45.4774 341.228 2.25 287.522 2.25Z",
    fill: "#00AA55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6_1790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 767,
    y: 2,
    width: 196,
    height: 193
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M767.39 2.25H962.188V194.965H767.39V2.25Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6_1790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M932.149 98.6085C932.149 135.353 901.93 165.248 864.789 165.248C827.647 165.248 797.428 135.353 797.428 98.6085C797.428 61.8645 827.647 31.9688 864.789 31.9688C901.93 31.9688 932.149 61.8645 932.149 98.6085ZM864.789 2.25C811.083 2.25 767.39 45.4774 767.39 98.6085C767.39 151.74 811.083 194.965 864.789 194.965C918.496 194.965 962.189 151.74 962.189 98.6085C962.189 45.4774 918.496 2.25 864.789 2.25Z",
    fill: "#00AA55"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6_1790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 593,
    y: 2,
    width: 169,
    height: 193
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.062 2.25781H761.673V194.979H593.062V2.25781Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6_1790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M752.465 3.42262C744.831 0.256996 736.01 3.81238 732.799 11.3604L677.375 141.78L621.928 11.3566C618.717 3.80668 609.9 0.245589 602.26 3.41692C594.625 6.59204 591.025 15.3208 594.237 22.8746L663.519 185.88C665.869 191.407 671.304 194.98 677.364 194.98C683.425 194.98 688.858 191.407 691.21 185.88L760.49 22.8803C762.045 19.2222 762.068 15.1839 760.55 11.5068C759.036 7.83168 756.164 4.96075 752.465 3.42262Z",
    fill: "#00AA55"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvoUs);
export default __webpack_public_path__ + "static/media/ConvoUS.de7701ff079856ff2860e366fd297dac.svg";
export { ForwardRef as ReactComponent };